import login from "~/routes/auth/login";
import register from "~/routes/auth/register";
import menu from "~/routes/auth/menu";
import address from "~/routes/auth/address";

export default [...login, ...register, ...menu, ...address];
